import styled from "styled-components";
import { motion } from "framer-motion";
import { getToneTokens } from "../../styles/shared";

export const Container = styled.div`
  position: fixed;
  /* 2026-08-04 (pedido do Igor): toasts 50px mais baixos que a posicao
     original (16px) — ficavam colados no topo, brigando com a topbar. */
  top: 66px;
  right: 16px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: min(380px, calc(100vw - 32px));
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`;

export const ToastItem = styled(motion.div)`
  ${({ $tone = "info" }) => {
    const tokens = getToneTokens(null, $tone);
    return `
      /* Fundo OPACO: o tint da tonalidade e composto SOBRE a surface solida.
         Sem isso, no tema escuro o --*-bg (rgba ~0.12) deixava o toast
         quase transparente e ilegivel sobre o conteudo da pagina. */
      background: linear-gradient(${tokens.background}, ${tokens.background}), var(--surface);
      border: 1px solid ${tokens.border};
      border-left: 3px solid ${tokens.accent};
      color: ${tokens.text};
    `;
  }}
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.45;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.28);
`;

export const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  margin-top: 1px;
  color: ${({ $tone = "info" }) => getToneTokens(null, $tone).accent};
`;

export const Message = styled.div`
  flex: 1;
  word-break: break-word;
  font-weight: 500;
`;

export const ActionButton = styled.button`
  background: none;
  border: 1px solid currentColor;
  color: inherit;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  opacity: 0.7;
  flex-shrink: 0;

  &:hover {
    opacity: 1;
  }
`;
